// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1VkgY","error":"InputSecondary_error__3zgiD","disabled":"InputSecondary_disabled__3MnlV"};